import { useRef } from 'react';
import { isFunction } from '@okee-uikit/react-utils';
export function useConst(initialValue) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = {
      value: isFunction(initialValue) ? initialValue() : initialValue
    };
  }

  return ref.current.value;
}